import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_STARTER_MEDIA_INQUIRY = defineFcm('petition_starter_media_inquiry')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				enabled: { type: 'boolean' },
				url: { type: 'string' },
			},
		}),
	)
	.withDefault({
		enabled: false,
		url: '',
	})
	.toConfig({
		owner: 'squad-capybara',
		scope: 'corgi-front-end',
		context: 'Petition Page',
		description:
			'This FC controls showing the petition starter media inquiry button and the url link on the Petition page',
		template: {
			enabled: false,
			url: '',
		},
		import: false,
	});
